module.exports = __webpack_public_path__ + "assets/img/bus4.940d493e.png";